import {
  Component,
  ViewChild,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';


@Component({
  selector: 'app-wizardpage-step2-welcome',
  templateUrl: './wizardpage-step2.component.html',
  styleUrls: ['./wizardpage-step2.component.scss'],
})
export class WizardpageStep2WelcomeComponent implements OnInit {
  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  initForm: any;
  isfetching: boolean;


  constructor() {}


  ngOnInit(): void {


this.isfetching = false;

  }



  decreasePage() {
    this.pagecountevnt.emit(0);
  }




  step2Submitted() {

    this.isSubmitted = true;
    this.continueevnt.emit({test: 'test'});
    this.pagecountevnt.emit(1);

    return true;
  }


  isFetching(e) {
    this.isfetching = e; }
}
